import { noTouch } from '@/assets/styles/mixins.css'
import styled from 'styled-components'

const Search = styled.form`
  position: relative;
  width: 100%;
  border-radius: 32px;
  overflow: hidden;
`

Search.Submit = styled.button`
  position: absolute;
  top: 0;
  left: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 48px;
  height: 100%;
  color: var(--color-decor);
  border-radius: 32px;
  transition: color 0.3s ease;

  ${noTouch()`
    &:hover, &:focus {
      color: var(--color-decor-hover);

      svg {
        transform: scale(1.2);
      }
    }
  `}

  & > svg {
    width: 16px;
    height: auto;
    transition: transform 0.3s ease-out;
  }
`

Search.Reset = styled.button`
  position: absolute;
  top: 0;
  right: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 48px;
  height: 100%;
  color: var(--color-border);
  border-radius: 32px;
  transition: color 0.3s ease;

  &::after,
  &::before {
    content: '';
    position: absolute;
    width: 18px;
    height: 2px;
    border-radius: 2px;
    background: currentColor;
  }

  &::after {
    transform: rotate(45deg);
  }

  &::before {
    transform: rotate(-45deg);
  }

  ${noTouch()`
    &:hover, &:focus {
      color: var(--color-secondary);
    }
  `}
`

Search.Input = styled.input`
  width: 100%;
  padding: 13px 50px 14px;
  font-size: 16px;
  line-height: 1.2;
  color: var(--color-main);
  caret-color: currentColor;
  background: var(--color-bg-accent);

  &::placeholder {
    line-height: normal;
    color: var(--color-extra);
  }
`

export default Search
